import React from 'react';
import { Tooltip } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';

interface Props {
  ms?: number;
  startedAt?: string;
  completedAt?: string;
  style?: React.CSSProperties;
}

function formatMs(ms: number): string {
  if (ms < 1000) return `${ms}ms`;
  if (ms < 60_000) return `${(ms / 1000).toFixed(1)}s`;
  const m = Math.floor(ms / 60_000);
  const s = Math.floor((ms % 60_000) / 1000);
  return `${m}m ${s}s`;
}

function calcMs(startedAt?: string, completedAt?: string): number | null {
  if (!startedAt || !completedAt) return null;
  const diff = new Date(completedAt).getTime() - new Date(startedAt).getTime();
  return diff > 0 ? diff : null;
}

const DurationBadge: React.FC<Props> = ({ ms, startedAt, completedAt, style }) => {
  const duration = ms != null ? ms : calcMs(startedAt, completedAt);
  if (duration == null || duration <= 0) return null;
  return (
    <Tooltip title={`${duration}ms`}>
      <span style={{ color: '#8b949e', fontSize: 11, whiteSpace: 'nowrap', ...style }}>
        <ClockCircleOutlined style={{ marginRight: 3 }} />
        {formatMs(duration)}
      </span>
    </Tooltip>
  );
};

export default DurationBadge;
export { formatMs, calcMs };
